<template>
    <div>
        <b-card no-body v-if="recept">
    
            <b-tabs card>
                <b-tab title="Komentáře" active>
                    <b-card-text v-if="commentData">
                        
                        <comment :key="OneComment.text" v-for="OneComment in commentData.data" :uzivatel="OneComment.jmeno" :text="OneComment.text" :rating="OneComment.rating" :maxLength="2000" :increment="0.5"></comment>
                    </b-card-text>
                </b-tab>
                <b-tab title="Vytvoř komentář">
                    <b-card-text v-if="recept">
                        <createComment :nameOfRecept="recept.nazev"></createComment>
                    </b-card-text>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
import axios from "axios";
import createComment from "./createComment.vue";
import comment from "./comment.vue";

export default {
    props: {
        recept: Object
    },
    data: () => {
        return {
            errors: [],
            commentData: []
        };
    },
    components: {
        createComment,
        comment
    },
    created() {

        console.log("start " + this.recept.nazev);
        let interval = setInterval(() => {
                if (typeof this.recept.nazev !== "undefined") {
                    axios
                        .get(`https://kucharka.zvara.cz/getComment.php`, { //http://nasekucharka.8u.cz/nove/getComment.php
                            params: { name: this.recept.nazev }
                        })
                        .then(response => {
                            this.commentData = response;


                        })
                        .catch(e => {
                            this.errors.push(e);
                        });
                        clearInterval(interval);
                }
            }, 500);
    }
};
</script>